import React, { useState } from "react";
import {
  DialogActions,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import Swal from "sweetalert2";
import { Search } from "@mui/icons-material";
import { useFormikContext } from "formik";
import NumberFormat from "react-number-format";
import { CurrencyFormat } from "../../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchWarehouse from "../../../inventory/warehouses/searchWarehouse";
import SearchTax from "../../../setup/finance/searchTax";
import { amountByPercent, percentByAmount } from "../../../../../utils/utils";
import SearchOutletStocks from "../../outlets/outletDetail/searchOutletStocks";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";

function PosItemDetail({ itemIndex = 0, onCloseItemDetail, onSaveChanges }) {
  const { values } = useFormikContext();
  const [itemSelected, setItemSelected] = useState(
    values.salesPosItem[itemIndex]
  );
  const [openSearchStock, setOpenSearchStock] = useState(false);
  const [openSearchTax, setOpenSearchTax] = useState(false);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);

  function setItemValue(propertyName = "", value) {
    if (
      propertyName === "qty" ||
      propertyName === "unitPrice" ||
      propertyName === "taxPercent" ||
      propertyName === "discountPercent" ||
      propertyName === "discountAmount"
    ) {
      setItemSelected(
        setItemDetailFieldChange(value, propertyName, { ...itemSelected })
      );
    } else {
      const itemSelectedTmp = { ...itemSelected };
      itemSelectedTmp[propertyName] = value;
      setItemSelected(itemSelectedTmp);
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <h5>{itemSelected.itemName}</h5>
          <h5>
            Total Price :{" "}
            <NumberFormat
              value={itemSelected.totalPrice}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div>
                  {values.currencyCode} {value}
                </div>
              )}
            />
          </h5>
          <FormControl
            variant="outlined"
            size="small"
            margin="normal"
            fullWidth
          >
            <InputLabel id="receiveType">Receive Type</InputLabel>
            <Select
              labelId="receiveType"
              id="receiveType"
              value={itemSelected.receiveType}
              onChange={(e) => {
                const itemSelectedTmp = { ...itemSelected };
                itemSelectedTmp.receiveType = e.target.value;
                itemSelectedTmp.warehouseID = 0;
                itemSelectedTmp.warehouseName = "";
                setItemSelected(itemSelectedTmp);
              }}
              label="Receive Type"
            >
              <MenuItem value={1}>Take Away</MenuItem>
              <MenuItem value={2}>Delivery</MenuItem>
              <MenuItem value={3}>Request Item</MenuItem>
            </Select>
          </FormControl>
          {itemSelected.receiveType === 3 ? (
            <React.Fragment>
              <TextField
                id="warehouseName"
                type="text"
                label="Warehouse Name"
                value={itemSelected.warehouseName}
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <BootstrapTooltip title="Search">
                        <IconButton
                          type="button"
                          aria-label="Search"
                          onClick={() => setOpenSearchWarehouse(true)}
                          edge="end"
                        >
                          <Search />
                        </IconButton>
                      </BootstrapTooltip>
                    </InputAdornment>
                  ),
                  readOnly: true,
                }}
              />
            </React.Fragment>
          ) : null}
          <TextField
            id="qty"
            type="number"
            label="Quantity"
            value={itemSelected.qty}
            variant="outlined"
            size="small"
            margin="normal"
            fullWidth
            onChange={(e) => setItemValue("qty", parseFloat(e.target.value))}
            inputProps={{
              readOnly: itemSelected.discountFreeItemID > 0 ? true : false,
            }}
          />
          <TextField
            id="unitPrice"
            type="text"
            label="Unit Price"
            value={itemSelected.unitPrice}
            variant="outlined"
            size="small"
            margin="normal"
            fullWidth
            onChange={(e) =>
              setItemValue("unitPrice", parseFloat(e.target.value))
            }
            InputProps={{
              inputComponent: CurrencyFormat,
              startAdornment: (
                <InputAdornment position="start">
                  {values.currencyCode}
                </InputAdornment>
              ),
            }}
            inputProps={{
              style: { textAlign: "right" },
              readOnly: itemSelected.discountFreeItemID > 0 ? true : false,
            }}
          />
          <TextField
            id="batchID"
            type="text"
            label="Batch ID"
            value={itemSelected.batchID}
            variant="outlined"
            size="small"
            margin="normal"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <BootstrapTooltip title="Search">
                    <IconButton
                      type="button"
                      aria-label="Search"
                      onClick={() => setOpenSearchStock(true)}
                      edge="end"
                    >
                      <Search />
                    </IconButton>
                  </BootstrapTooltip>
                </InputAdornment>
              ),
              readOnly: true,
            }}
          />
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <TextField
                id="taxPercent"
                type="number"
                fullWidth
                label="Tax Percent %"
                value={itemSelected.taxPercent}
                margin="normal"
                variant="outlined"
                InputProps={{
                  endAdornment:
                    itemSelected.discountFreeItemID === 0 ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setOpenSearchTax(true);
                          }}
                          aria-label="Search Unit of Measurement"
                          edge="end"
                        >
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  readOnly: true,
                }}
              />
            </div>
            <div className="col-sm-8 col-md-8 col-lg-8">
              <TextField
                id="taxAmount"
                type="text"
                fullWidth
                label="Tax Amount"
                value={itemSelected.taxAmount}
                margin="normal"
                variant="outlined"
                InputProps={{
                  inputComponent: CurrencyFormat,
                  style: { textAlign: "right" },
                  readOnly: true,
                }}
                inputProps={{ style: { textAlign: "right" } }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <TextField
                id="discountPercent"
                type="number"
                onChange={(e) =>
                  setItemValue("discountPercent", parseFloat(e.target.value))
                }
                fullWidth
                label="Discount Percent %"
                value={itemSelected.discountPercent}
                margin="normal"
                variant="outlined"
                inputProps={{
                  readOnly: itemSelected.discountFreeItemID > 0 ? true : false,
                }}
              />
            </div>
            <div className="col-sm-8 col-md-8 col-lg-8">
              <TextField
                id="discountAmount"
                type="text"
                onChange={(e) =>
                  setItemValue("discountAmount", parseFloat(e.target.value))
                }
                fullWidth
                label="Discount Amount"
                value={itemSelected.discountAmount}
                margin="normal"
                variant="outlined"
                InputProps={{
                  inputComponent: CurrencyFormat,
                  style: { textAlign: "right" },
                }}
                inputProps={{
                  style: { textAlign: "right" },
                  readOnly: itemSelected.discountFreeItemID > 0 ? true : false,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchWarehouse}
        title="Search Warehouse"
        onCloseDialog={() => {
          setOpenSearchWarehouse(false);
        }}
        maxWIdth="md"
      >
        <SearchWarehouse
          allWarehouses={true}
          onSelectWarehouse={(warehouse) => {
            const itemSelectedTmp = { ...itemSelected };
            itemSelectedTmp.warehouseID = warehouse.ID;
            itemSelectedTmp.warehouseName = warehouse.warehouseName;
            setItemSelected(itemSelectedTmp);
            setOpenSearchWarehouse(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchWarehouse(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchTax}
        title="Search Tax"
        onCloseDialog={() => {
          setOpenSearchTax(false);
        }}
        maxWIdth="sm"
      >
        <SearchTax
          onSelectTax={(tax) => {
            setItemValue("taxPercent", parseFloat(tax.taxPercent));
            setOpenSearchTax(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchTax(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchStock}
        title="Search Stock"
        onCloseDialog={() => {
          setOpenSearchStock(false);
        }}
        //fullScreen={true}
        maxWIdth="lg"
      >
        <SearchOutletStocks
          outletID={values.outletID}
          itemID={itemSelected.itemID}
          varCode={itemSelected.varCode}
          onSelectStock={(stock) => {
            setItemValue("batchID", stock.BatchID);
            setOpenSearchStock(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchStock(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseItemDetail(false);
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="button"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={() => {
            if (
              itemSelected.receiveType === 3 &&
              itemSelected.warehouseID === 0
            ) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text: "Please select Warehouse for item request",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              return;
            }
            if (itemSelected.receiveType === 2 && itemSelected.batchID === 0) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text: "Please select Batch ID for Delivery",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              return;
            }
            onSaveChanges(itemSelected);
          }}
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </React.Fragment>
  );

  function setItemDetailFieldChange(value, propertyName, itemSelected) {
    const totalPrice = itemSelected.qty * itemSelected.unitPrice;
    let taxAmount = 0;
    let discountAmount = 0;
    let discountPercent = 0;
    let targetValue = 0;
    if (value === "") {
      targetValue = 0;
    } else {
      targetValue = value;
    }
    switch (propertyName) {
      case "qty":
        itemSelected.totalPrice =
          parseFloat(targetValue) * itemSelected.unitPrice;
        if (itemSelected.taxPercent > 0) {
          taxAmount = amountByPercent(
            parseFloat(itemSelected.taxPercent),
            itemSelected.totalPrice
          );
          itemSelected.taxAmount = taxAmount;
        }
        if (itemSelected.discountPercent > 0) {
          discountAmount = amountByPercent(
            parseFloat(itemSelected.discountPercent),
            itemSelected.totalPrice
          );
          itemSelected.discountAmount = discountAmount;
        } else if (itemSelected.discountAmount > 0) {
          discountPercent = percentByAmount(
            parseFloat(itemSelected.discountAmount),
            itemSelected.totalPrice
          );
          itemSelected.discountPercent = discountPercent;
          discountAmount = itemSelected.discountAmount;
        }
        itemSelected.subTotal =
          itemSelected.totalPrice - discountAmount + taxAmount;
        break;
      case "unitPrice":
        itemSelected.totalPrice = parseFloat(targetValue) * itemSelected.qty;
        if (itemSelected.taxPercent > 0) {
          taxAmount = amountByPercent(
            parseFloat(itemSelected.taxPercent),
            itemSelected.totalPrice
          );
          itemSelected.taxAmount = taxAmount;
        }

        if (itemSelected.discountPercent > 0) {
          discountAmount = amountByPercent(
            parseFloat(itemSelected.discountPercent),
            itemSelected.totalPrice
          );
          itemSelected.discountAmount = discountAmount;
        } else if (itemSelected.discountAmount > 0) {
          discountPercent = percentByAmount(
            parseFloat(itemSelected.discountAmount),
            itemSelected.totalPrice
          );
          itemSelected.discountPercent = discountPercent;
          discountAmount = itemSelected.discountAmount;
        }
        itemSelected.subTotal =
          itemSelected.totalPrice - discountAmount + taxAmount;
        break;
      case "taxPercent":
        taxAmount = amountByPercent(parseFloat(targetValue), totalPrice);
        itemSelected.subTotal = itemSelected.totalPrice;
        itemSelected.taxAmount = taxAmount;
        itemSelected.totalPrice =
          totalPrice - itemSelected.discountAmount + taxAmount;
        break;
      case "discountPercent":
        discountAmount = amountByPercent(parseFloat(targetValue), totalPrice);
        itemSelected.subTotal = itemSelected.totalPrice;
        itemSelected.discountAmount = discountAmount;
        itemSelected.totalPrice =
          totalPrice - discountAmount + itemSelected.taxAmount;
        break;
      case "discountAmount":
        discountPercent = percentByAmount(parseFloat(targetValue), totalPrice);
        itemSelected.subTotal = itemSelected.totalPrice;
        itemSelected.discountPercent = discountPercent;
        itemSelected.totalPrice =
          totalPrice - parseFloat(targetValue) + itemSelected.taxAmount;
        break;
      default:
        break;
    }
    itemSelected[propertyName] = parseFloat(targetValue);
    return itemSelected;
  }
}

export default PosItemDetail;
